import { apiService } from './api';
import { AttributeDefinition, AttributeSet, ProductAttributes } from '../types';

const ATTRIBUTES_API = '/attributes';

export interface SetProductAttributeValue {
  attributeDefinitionId: number;
  value?: string | null;
}

export interface SetProductAttributesRequest {
  values: SetProductAttributeValue[];
}

export interface SaveAttributeDefinitionRequest {
  code?: string;          // create only — immutable afterwards
  name: string;
  description?: string;
  dataType?: string;      // create only — immutable afterwards
  options?: string[];
  unit?: string;
  appliesToAllProducts: boolean;
  categoryIds: number[];
  isRequired: boolean;
  sortOrder?: number;
  isActive: boolean;
}

export const attributeService = {
  // Definitions
  getDefinitions: (includeInactive = false) =>
    apiService.get<AttributeDefinition[]>(`${ATTRIBUTES_API}/definitions`, { includeInactive }),

  getDefinition: (id: number) =>
    apiService.get<AttributeDefinition>(`${ATTRIBUTES_API}/definitions/${id}`),

  createDefinition: (data: SaveAttributeDefinitionRequest) =>
    apiService.post<AttributeDefinition>(`${ATTRIBUTES_API}/definitions`, data),

  updateDefinition: (id: number, data: SaveAttributeDefinitionRequest) =>
    apiService.put<AttributeDefinition>(`${ATTRIBUTES_API}/definitions/${id}`, data),

  deleteDefinition: (id: number) =>
    apiService.delete<void>(`${ATTRIBUTES_API}/definitions/${id}`),

  // Sets
  getSets: (includeInactive = false) =>
    apiService.get<AttributeSet[]>(`${ATTRIBUTES_API}/sets`, { includeInactive }),

  getSetById: (id: number) =>
    apiService.get<AttributeSet>(`${ATTRIBUTES_API}/sets/${id}`),

  // Product form — module block + custom attributes with scope
  getForm: () =>
    apiService.get<ProductAttributes>(`${ATTRIBUTES_API}/form`),

  // Product values
  getProductAttributes: (productId: number) =>
    apiService.get<ProductAttributes>(`${ATTRIBUTES_API}/product/${productId}`),

  setProductAttributes: (productId: number, data: SetProductAttributesRequest) =>
    apiService.put<ProductAttributes>(`${ATTRIBUTES_API}/product/${productId}`, data),
};

export default attributeService;
